export const formatPrice = price => {
  return price?.toFixed(2);
};

export const getProductSlug = pathname => {
  const findSlug = RegExp(/\/(.*)\/details/);
  const foundSlug = findSlug.exec(pathname);
  return foundSlug ? foundSlug[1] : '';
};
